(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taaralu-product-carousel"] && !Shopify.designMode) return;
  try {
    
  function initialiseTaaraluCarousels() {
    document.querySelectorAll('[data-taaralu-carousel]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.th-carousel__track');
      const previous = section.querySelector('.th-carousel__arrow--prev');
      const next = section.querySelector('.th-carousel__arrow--next');
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      [previous, next].forEach((button, index) => button.addEventListener('click', () => {
        track.scrollBy({left: (index ? 1 : -1) * track.clientWidth * 0.8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  initialiseTaaraluCarousels();
  document.addEventListener('shopify:section:load', initialiseTaaraluCarousels);

  } catch(e) { console.error(e); }
})();
})();
